<p-toast></p-toast>
<div class="row loginRow">
    <span class="imgCont">
        <img src="assets/MicrosoftTeams-image.png" class="imgPosit">
        <a (click)="navigateToLogin('en')">
            <img src="assets/circled-left-2.png" class="back-arrow-img">
        </a>
    </span>
    <br />

    <mat-card class="login-card">
        <mat-card-actions>
            <mat-card-title class="loginTitle">{{ 'RESTORE_PASS_RESTORE' | translate}}</mat-card-title>
        </mat-card-actions>

        <mat-card-subtitle class="loginSubtitle">
            {{ 'RESTORE_PASS_TEXT_EMAIL' | translate}}
        </mat-card-subtitle>
        <div *ngIf="loadingApi" class="loading-indicator">
            <!-- Puedes personalizar esto según tus necesidades, por ejemplo, mostrar una animación de carga -->
            <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
            <p [style]="{'width':'40px', 'height':'40px'}"> {{ 'RESTORE_PASS_LOADING' | translate}} </p>
        </div>
        <mat-card-content>
            <div class="p-field mb-20">
                <input [disabled]="loadingApi" [(ngModel)]="email" class="custom-input" placeholder="{{ 'RESTORE_PASS_EMAIL' | translate}}">
                <button [disabled]="loadingApi"  class="custom-button mt-3" (click)="resetPassword()">{{ 'RESTORE_PASS_SEND' | translate}}</button>
            </div>
        </mat-card-content>
    </mat-card>

</div>

